import * as React from 'react';
import { TextButton, Modal } from '../../Components';
import styled from 'styled-components';

type IProps = React.ButtonHTMLAttributes<any>;

interface IState {
  isModalOpen: boolean;
}

const StyledButton = styled(TextButton)`
  border-radius: 50%;
  padding: 0px;
  min-width: inherit;
  height: 17px;
  width: 17px;
  border: 2px solid ${(props) => props.theme['primaryColor']};
  display: block;
  font-size: 0.8em;
  font-weight: bolder;
  line-height: 100%;
  text-align: center;
`;



const StyledModalContent = styled.div`
  padding: 23px;
  display: flex;
  height: 75%;
  justify-content: center;
  align-items: center;
  color: #504a4a
`;

export class HelpButton extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isModalOpen: false
    };
  }

  render() {
    const { children, ...rest } = this.props;
    return (
      <>
        <Modal
          isVisible={this.state.isModalOpen}
          size='small'
          outterClick={() => { this.setState({ isModalOpen: false }); }}
        >
          <StyledModalContent>
            {children}
          </StyledModalContent>
        </Modal>
        <StyledButton {...rest} onClick={() => this.setState({ isModalOpen: true })}>?</StyledButton>
      </>
    );
  }
}